import React, { useState, useEffect } from "react";
import { GET_API_URLS } from "../../../../utils/constant";
import jwtInterceoptor from "../../../../api/jwtInterceptor";
import {
    CarouselBannerCard,
  Loader,
} from "../../../../components/ui";
import { useAuth } from "../../../../context/AuthProvider";
import styles from "./style.module.scss";

const Carousel = () => {
  const [loading, setLoading] = useState(true);
  const [bannerList, setBannerList] = useState(null);
  const [error, setError] = useState(false);
  const { setAuth } = useAuth();

  useEffect(() => {
    // Getting Promotions List
    jwtInterceoptor
      .get(GET_API_URLS.CAROUSEL)
      .then((response) => {
        // console.log(response);
        setLoading(false);
        // setAuth((prev) => ({ ...prev, banner: response.data }));
        // const sortedSequence = response?.data.filter(
        //   (a, b) => a.sequence - b.sequence
        // );
        setBannerList(response.data);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 403) {
          setError("You dont have permission to access this page.");
        } else {
          setError("There was a problem while loading the data.");
        }
        console.log("Error", error);
      });
  }, [setAuth]);

  return (
    <div className={styles.webPromotionPage}>
      {error ? (
        <h3 style={{ textAlign: "center" }}>{error}</h3>
      ) : (
        <>
          {loading ? (
            <div className={styles.loadingPage}>
              <Loader />
            </div>
          ) : bannerList ? (
            <div className={styles.promotionBlock}>
              {bannerList?.length > 0 ? (
                bannerList
                  .sort((a, b) => a.sequence - b.sequence)
                  .map((val, i) => (
                    <CarouselBannerCard
                      id={val.id}
                      image={val.image}
                      //   title={val.name}
                      data={{ ...val }}
                      key={i}
                      sequenceNumber={val.index}
                    />
                  ))
              ) : (
                <div>
                  <h2 style={{ textAlign: "center" }}>No Carousel Banner</h2>
                </div>
              )}
            </div>
          ) : null}
        </>
      )}
    </div>
  );
};

export default Carousel;
